exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-view-contents {\n  margin: 1em auto;\n  max-width: 1000px; }\n\n.progress-indicators {\n  width: 1000px;\n  margin: 0 auto;\n  overflow: hidden;\n  margin-bottom: 1em;\n  background: white;\n  padding: 1em;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n\n.section {\n  width: 1000px;\n  margin: 1em auto;\n  background: white;\n  clear: both; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/views/dashboardView/dashboardView.component.scss
// module id = ./src/app/modules/dashboard/views/dashboardView/dashboardView.component.scss
// module chunks = main